export const SUPPORTED_SERVICES = [
	'CAREGIVING_WITH_UGOS_CAR',
	'CAREGIVING_WITH_USERS_CAR',
	'CAREGIVING_WITHOUT_CAR',
	'CAREGIVING_VIA_TELEMEDICINE',
	'ERRANDS',
	'PHONE_ASSISTANCE',
];
